<template>
  <div class="ins-main gamelobby-main">
    <div class="blackHeading">
      <h1>{{$t('lang_men_rollinbet')}}</h1>
      <h3>{{$t('lang_themeHeading_wechatGame_narrative')}}</h3>
    </div>
    <div class="lobbyContent">
      <div class="gamelobby-inner">
        <div class="gamelobby-cell">
          <div class="group-title">
            <span>
              <i class="icon-wechat"></i>
              {{$t('lang_gameList')}}
            </span>
          </div>
          <div class="game-leftside" ref="cusScrollBar">
            <ul class="game-list">
              <li v-for="(list, index) in wechaGames" :gameId="list.id" :key="index" @click="gameTab(index)">
                <img :src='require(`@img/${list.img}`)'>
              </li>
            </ul>
          </div>
        </div>
        <div class="gamelobby-cell">
          <div class="template">
            <iframe ref="gamebox" :src="file+nowShow.url" frameborder="0" width="100%" height="100%"></iframe>
          </div>
        </div>
        <div class="gamelobby-cell">
          <div class="gameInfo">
            <div class="heading">{{$t('lang_playMethod')}}</div>
            <ul v-html=$t(nowShow.intro)></ul>
          </div>
          <div class="gameInfo">
            <div class="heading">{{$t('lang_gameFeature')}}</div>
            <ul v-html=$t(nowShow.feature)></ul>
          </div>
        </div>
      </div>
    </div>
  </div>    
</template>
<script>
import $ from 'jquery'
import wechaGame from '@data/games.json'
import {BACKEND_LOCATION} from '@api/Endpoints'

export default {
  name: 'Gamelobby',
  data(){
    return{
      wechaGames: [],
      nowShow: {},
      file:BACKEND_LOCATION.file+'/assets/dist/mem/games/'
    }
  },
  methods: {
    wechaGameInfo(info){
      this.wechaGames = info.wechat.game
    },
    gameTab(index){
      this.nowShow = this.wechaGames[index]
    }
  },
  created(){
    this.wechaGameInfo(wechaGame)
    this.gameTab(0)
  },
  mounted() {
		this.$store.dispatch('setLoadshow',false)
  },
  beforeDestroy(){
    this.$store.dispatch('setLoadshow',true)
  }
}
</script>
<style lang="sass">
  @import '@css/gamelobby.sass'
</style>
